import { type ComponentProps, useCallback, useEffect, useRef } from 'react';
import { StyledTextArea } from './styles';

export const AIPromptTextArea: React.FC<ComponentProps<'textarea'>> = (props) => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  const resizeTextArea = useCallback(() => {
    if (!textareaRef.current) {
      return;
    }

    textareaRef.current.style.height = 'auto';
    textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
  }, []);

  useEffect(() => {
    resizeTextArea();
    window.addEventListener('resize', resizeTextArea);

    return () => {
      window.removeEventListener('resize', resizeTextArea);
    };
  }, [resizeTextArea]);

  return (
    <StyledTextArea
      {...props}
      ref={textareaRef}
      onChange={(e) => {
        props.onChange?.(e);
        resizeTextArea();
      }}
    />
  );
};
